import {getSupplierList} from "@/api/Supplier"

export default {
  addSupplier({ commit }, supplier) {
    return new Promise((resolve, reject) => {
      commit('ADD_SUPPLIER', supplier)
          resolve()
        .catch((error) => { reject(error) })
    })
  },
  fetchDataListItemsSupplier({ commit },payload) {
    return new Promise((resolve, reject) => {
      getSupplierList(payload)
      .then((response) => {
        if(response.status === 200){
        commit('SET_SUPPLIER', response.data);
        resolve(response);
        }else{
          reject(new Error("Listeleme İşlemi Başarısız ! " + response.status));
        }
      })
      .catch(error => {
        reject(new Error("Sunucu Bağlantısı Başarısız !"));
      })
    })
  },
  updateSupplier({ commit }, supplier) {
    return new Promise((resolve, reject) => {
      commit('UPDATE_SUPPLIER', supplier)
          resolve()
        .catch((error) => { reject(error) })
    })
  },
  removeSupplier({ commit }, supplierId) {
    return new Promise((resolve, reject) => {
      commit('REMOVE_SUPPLIER', supplierId)
          resolve();
    })
  }
};